<script>
import moment from "@/utils/moment";
import Modal from "@/components/_Shared/Modal";
import accountMixin from "@/mixins/accountMixin";
import IconTooltip from "@/components/_Shared/Users/Status/IconTooltip";

export default {
  mixins: [accountMixin],

  components: {
    Modal,
    IconTooltip
  },
  data() {
    return {
      headers: [
        {
          text: "Evento",
          value: "event_type",
          align: "center",
          sortable: false
        },
        { value: "data-table-expand", align: "center" }
      ]
    };
  },
  props: {
    enabled: {
      type: Boolean,
      required: true
    },
    events: {
      type: Array,
      required: true
    }
  },

  methods: {
    event_name(event) {
      return event.split(".")[1].toLowerCase();
    }
  },

  computed: {
    accountEvents() {
      return this.events
        .map(event => {
          return {
            ...event,
            created_at: moment(event.created_at)
          };
        })
        .sort((a, b) => b.created_at.valueOf() - a.created_at.valueOf());
    }
  }
};
</script>

<template>
  <modal title="Eventos" size="md" v-if="enabled" @close="$emit('close')">
    <template slot="body">
      <v-data-table
        :headers="headers"
        :items="accountEvents"
        show-expand
        single-expand
      >
        <template v-slot:item.event_type="{ item }">
          <icon-tooltip :options="getStatus(event_name(item.event_type))" />
          <v-chip small outlined>{{
            event_name(item.event_type) | getAccountStatus("event")
          }}</v-chip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td align="center" :colspan="headers.length">
            <p>
              <b>DESCRICAO:</b>
              {{ item.description }}
            </p>
          </td>
        </template>
      </v-data-table>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">
        fechar
      </button>
    </template>
  </modal>
</template>

<style scoped>
li {
  list-style: none;
  text-transform: capitalize;
  font-weight: 300;
}

li:not(:last-child) {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/FormData/Events/Events.vue